
const DokumentNaloga = function(DS) {
    return DS.defineResource({
        name: 'DokumentNaloga',
        endpoint: '/dokumentNaloga'
    });
};

DokumentNaloga.$inject = ['DS'];


export {DokumentNaloga};



// WEBPACK FOOTER //
// ./app/models/dokumentNaloga.js